import { useEffect, useState } from 'react';
import { GrowthBookProvider } from '@growthbook/growthbook-react';
import { QueryClientProvider } from '@tanstack/react-query';
import { Provider } from 'react-redux';
import { createRoot } from 'react-dom/client';
import { Spinner } from 'react-bootstrap';
import { queryClient } from './queryClient';
import App from './components/App';
import store from './store';

import { growthbook } from './growthbook';

const Root = () => {
  const [isReady, setIsReady] = useState(false);

  const init = async () => {
    try {
      await growthbook.init();
    } catch (error) {
      console.error(`App Init Failed: ${error?.message}`);
    }
    setIsReady(true);
  };

  useEffect(() => {
    init();
  }, []);

  if (!isReady) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', marginTop: '50px' }}>
        <Spinner
          animation="border"
          role="status"
          variant="info"
          style={{
            height: 30,
            width: 30,
            marginLeft: 20,
            marginTop: 10,
          }}
        />
      </div>
    );
  }

  return (
    <GrowthBookProvider growthbook={growthbook}>
      <Provider store={store}>
        <QueryClientProvider client={queryClient}>
          <App />
        </QueryClientProvider>
      </Provider>
    </GrowthBookProvider>
  );
};

// Get the root element
const container = document.querySelector('#root');

// Create a root
const root = createRoot(container);
root.render(<Root />);
